'use client';

import { ReactNode } from 'react';
import { AuthProvider } from '@/components/contexts/AuthContext';

interface AuthProviderWrapperProps {
    children: ReactNode;
}

const AuthProviderWrapper = ({ children }: AuthProviderWrapperProps) => (
    <AuthProvider>
        {children}
    </AuthProvider>
);

export default AuthProviderWrapper;
